import React, { Component, Fragment } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import PrivateRouteWrapper from "./PrivateRouteWrapper";
import Header from "./../components/wrapper/AdminHeader/AdminHeader";
import Content from "./../components/wrapper/AdminContent/AdminContent";
import AdminLanding from "../pages/admin/AdminLandingPage";
import Advertise from "../pages/admin/AdvertisePage";
import ClientUsers from "../pages/admin/ClientUserPage";
import CampaignPage from "../pages/admin/CampaignPage";
import CredentialPage from "../pages/admin/CredentialPage";
import DrivePage from "../pages/admin/DrivePage";
import VendorPage from "../pages/admin/VendorPage";
import EditVendorTruckPage from "../pages/admin/EditVendorTruckPage";
import FixListPage from "../pages/admin/FixListPage";
import ProductionPage from "../pages/admin/ProductionPage";
import InventoryPage from "../pages/admin/InventoryPage";
import RemovalsPage from "../pages/admin/RemovalsPage";
import PlaceholderTruckPage from "../pages/admin/PlaceholderTruckPage";
import PaymentsPage from "../pages/admin/PaymentsPage";
import TeamPage from "../pages/admin/TeamPage";
import TeamUserPage from "../pages/admin/TeamUserPage";
import BackdatePlaceholderPage from "../pages/admin/BackdatePlaceholderPage";
import ClientImpersonationPage from "../pages/admin/ClientImpersonationPage";
import ClientImpersonationPageTemp from "../pages/admin/ClientImpersonationPageTemp";
import Communication from "../pages/admin/Communication";
import PrintOrderSheet from "../pages/admin/PrintOrderSheet";


class AdminDashboardWrapper extends Component {
  render() {
    return (
      <Fragment>
        {/* <Header /> */}
        <Content>
          <Switch>
            <PrivateRouteWrapper
              roles={[1, 3]}
              path="/dashboard/admin/advertise/backdate/placeholders"
              component={BackdatePlaceholderPage}
            />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/advertise/client/impersonate/:client_id/campaign/:campaign_id" component={ClientImpersonationPageTemp} />
            {/* <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/advertise/client/impersonate/temp/:client_id/campaign/:campaign_id" component={ClientImpersonationPageTemp} /> */}
            <PrivateRouteWrapper roles={[1, 3]} path="/dashboard/admin/advertise/campaign/edit/:id">
              <CampaignPage edit />
            </PrivateRouteWrapper>
            <PrivateRouteWrapper roles={[1, 3]} path="/dashboard/admin/advertise/campaign" component={CampaignPage} />
            <PrivateRouteWrapper
              roles={[1, 3]}
              path="/dashboard/admin/advertise/user/:id/credential"
              component={CredentialPage}
            />
            <PrivateRouteWrapper roles={[1, 3]} path="/dashboard/admin/advertise/user" component={ClientUsers} />
            <PrivateRouteWrapper roles={[1, 3]} path="/dashboard/admin/advertise" component={Advertise} />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/drive/payments" component={PaymentsPage} />
            {/* <PrivateRouteWrapper
              roles={[1, 3]}
              path="/dashboard/admin/drive/placeholder/truck"
              component={PlaceholderTruckPage}
            /> */}
            <PrivateRouteWrapper
              roles={[1, 3]}
              path="/dashboard/admin/drive/macro"
              component={PlaceholderTruckPage}
            />
            <PrivateRouteWrapper
              roles={[1, 2, 3]}
              path="/dashboard/admin/drive/vendor/truck/edit/:id"
              component={EditVendorTruckPage}
            />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/drive/vendor/edit/:id">
              <VendorPage edit />
            </PrivateRouteWrapper>
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/drive/vendor/create" component={VendorPage} />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/drive" component={DrivePage} />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/fixlist" component={FixListPage} />
            <PrivateRouteWrapper roles={[1, 2, 3, 5]} path="/dashboard/admin/communication/:vendorName/:phoneNumber/:vendorId" component={Communication} />
            <PrivateRouteWrapper roles={[1, 2, 3, 5]} path="/dashboard/admin/communication" component={Communication} />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/production/inventory" component={InventoryPage} />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/production/print-order-sheet" component={PrintOrderSheet} />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/production/removals" component={RemovalsPage} />
            <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/production" component={ProductionPage} />

            <PrivateRouteWrapper roles={[1, 3]} path="/dashboard/admin/team/user/edit/:id">
              <TeamUserPage edit />
            </PrivateRouteWrapper>
            <PrivateRouteWrapper roles={[1, 3]} path="/dashboard/admin/team/user" component={TeamUserPage} />
            <PrivateRouteWrapper roles={[1, 3]} path="/dashboard/admin/team" component={TeamPage} />
            {/* <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin" component={AdminLanding} /> */}
            <Redirect from="/dashboard/admin" to="/dashboard/admin/advertise" />
          </Switch>
        </Content>
      </Fragment>
    );
  }
}

export default AdminDashboardWrapper;
